export default "/assets/site/images/sakk.jpg?a81f3772c258cd8087360afe083826ba";